module.exports = __webpack_public_path__ + "img/title_no.69612a4a.svg";